<template>

<b-container fluid>
  <b-form-row>
    <b-col>
      <b-form-row class="items-gap">
        <div class="form-group">
          <model-select v-model="project" :model-request="loadProjects" label="Proyecto" placeholder="Buscar por código"
                        :get-option-label="project => project.codeId + ' - ' + project.title"/>
        </div>
        <div class="form-group">
          <model-select v-model="client" :model-request="loadClients" label="Cliente" model-label="name" placeholder="Buscar por nombre"/>
        </div>
        <div class="form-group">
          <model-select v-model="user" :model-request="loadUsers" label="Operario" model-label="name" placeholder="Buscar por nombre"/>
        </div>
        <div v-if="!hideTypeFilter" class="form-group">
          <label>Tipo
            <b-form-select v-model="filters.workOrderTypeFilter" :options="typeOptions"/>
          </label>
        </div>
        <div v-if="!hideValidationStatusFilter" class="form-group">
          <label>Estado
            <b-form-select v-model="filters.validationStatus" :options="statusOptions"/>
          </label>
        </div>
        <div class="form-group">
          <label>Desde
            <b-form-input type="date" v-model="filters.from"/>
          </label>
        </div>
        <div class="form-group">
          <label>Hasta
            <b-form-input type="date" v-model="filters.to"/>
          </label>
        </div>
        <div class="form-group">
          <label>Id mínima
            <b-form-input type="number" v-model="filters['rangeIdDTO.initId']"/>
          </label>
        </div>
        <div class="form-group">
          <label>Id máxima
            <b-form-input type="number" v-model="filters['rangeIdDTO.endId']"/>
          </label>
        </div>
        <div class="form-group">
          <label>Última modificación
            <b-form-input type="date" v-model="filters.lastModifiedDate"/>
          </label>
        </div>
      </b-form-row>
    </b-col>
    <b-col cols="auto" class="d-flex flex-column justify-content-center pr-4">
      <b-button @click="$emit('click-search')" variant="primary" block>Buscar</b-button>
      <b-button v-if="!hideExportButton" @click="onClickExport" variant="info" block>Exportar</b-button>
      <b-button @click="clean" variant="secondary" block>Limpiar</b-button>
    </b-col>
  </b-form-row>
</b-container>

</template>

<script>

import api from '@/api/api'
import ModelSelect from '@/components/common/ModelSelect'

export default {
  name: 'WorkOrderFilter',
  components: {ModelSelect},
  model: {prop: 'filters'},
  props: {
    filters: {type: Object, required: true},
    hideTypeFilter: {type: Boolean, default: false},
    hideValidationStatusFilter: {type: Boolean, default: false},
    hideExportButton: {type: Boolean, default: false},
    typeList: 0
  },
  data() {
    return {
      project: null,
      client: null,
      user: null,
      typeOptions: [
        {text: 'Todos', value: null},
        {text: 'Ordinario', value: 'PROJECT'},
        {text: 'ADM', value: 'ADM'}
      ],
      statusOptions: [
        {text: 'Todos', value: null},
        {text: 'Pendiente 1ª Validación', value: 'PENDING_FIRST_VALIDATION'},
        {text: 'Pendiente 2ª Validación', value: 'PENDING_SECOND_VALIDATION'},
        {text: 'Confirmado', value: 'CONFIRMATED'}
      ]
    }
  },
  watch: {
    project(project) {
      this.filters.projectId = project && project.id
    },
    client(client) {
      this.filters.clientId = client && client.id
    },
    user(user) {
      this.filters.employeeId = user && user.id
    }
  },
  methods: {
    loadClients(name = null) {
      return api.client.index({name, size: 100, sort: 'name'}).then(paginator => paginator.content)
    },
    loadUsers(name = null) {
      return api.appUser.index({name, size: 100, sort: 'name'}).then(paginator => paginator.content)
    },
    loadProjects(codeId = null) {
      if (codeId && isNaN(codeId)) {
        return new Promise(resolve => resolve([]))
      }
      return api.project.index({codeId, size: 10000, sort: 'codeId'}).then(paginator => paginator.content)
    },
    clean() {
      Object.keys(this.filters).forEach(key => { this.filters[key] = null })
      this.project = null
      this.client = null
      this.user = null
    },
    onClickExport() {
      switch (this.typeList) {
        case 0:
          // Filtro 1º validacion
          api.workOrder.exportIndex(this.filters)
          break
        case 1:
          // Filtro 2º validacion
          api.workOrder.exportAdmin(this.filters)
          break
        case 2:
          // Filtro historico
          api.workOrder.exportHistory(this.filters)
          break
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/workOrder/partials/WorkOrderFilter.vue